/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { ReactNode } from 'react'
import { StaticQuery, graphql, useStaticQuery } from 'gatsby'
import GlobalStyle from '@styles/global/globalStyles'
import Header from './header'
import styled, { ThemeProvider } from 'styled-components'
import { ITheme } from '@styles/themes/darkTheme'
import DefaultTheme from '@styles/themes/defaultTheme'
import Footer from '@components/footer'
import { device } from '@styles/global/breakpoints'
import UseSiteProvider from '@hooks/useSite/useSiteProvider'
import { siteInitialState } from '@hooks/useSite'

interface IProps {
  theme?: ITheme
  children: ReactNode
  path: string
  footer?: boolean
  stickyNav?: boolean
  showNav?: boolean
}
const Layout = ({ children, theme = DefaultTheme, path, footer = true, stickyNav = true, showNav = true }: IProps) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const initialState = siteInitialState

  return (
    <ThemeProvider theme={theme}>
      <UseSiteProvider defaultState={initialState}>
        <>
          <GlobalStyle key="globalStyles" />
          <Header
            showNav={showNav}
            siteTitle={data.site.siteMetadata.title}
            path={path}
            stickyNav={stickyNav}
          />
          <Main showNav={showNav} path={path}>
            {children}
          </Main>
          {footer && <Footer />}
        </>
      </UseSiteProvider>
    </ThemeProvider>
  )
}

const Main = styled.main<{
  showNav: boolean,
  path: string
}>`
  padding-top: ${props => props.path === '/' || !props.showNav ? '0' : '65px'};
  background: ${props => props.theme.mainBg ? props.theme.mainBg : ''};
  color: ${props => props.theme.bodyText ? props.theme.bodyText : 'inherit'};
  // h4, p, li{
  //   color: ${props => props.theme.bodyText ? props.theme.bodyText : ''};
  // }
  
  a{
    color: ${props => props.theme.linkColor};
    &:hover{
      color: ${props => props.theme.linkHoverColor};
    }
  }
  @media ${device.laptop}{
    padding-top: ${props => props.path === '/' ? '0' : '80px'}; 
  }
`
export default Layout
